export enum FilestackUploaderTypes {
  Area = 'area',
  Button = 'button',
  Text = 'text'
}
